import React, { useState, useEffect } from 'react';
import { Paper, Box, Grid , Chip, Typography,  CircularProgress , Divider , Card, CardContent, } from '@mui/material';
import ApiService from '../../functions/apiService';
import moment from "moment";
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import Modal from 'react-bootstrap/Modal';
import MyTable from '../../components/Schedule/MyTable';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const VacationBidsUser = () => {
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [bidsData , setBidsData] = useState([]);
    const [selectedData , setSelectedData] = useState([]);
    const [myBidsData , setMyBidsData] = useState([])
    const navigate = useNavigate();

    const columns = [
        { 
            field: 'Start_Date', 
            headerName: 'Period Start Date', 
            minWidth : 180,
            valueGetter: (params) => moment(params.row.Start_Date).format('MM/DD/YYYY'),
        },
        { 
            field: 'End_Date', 
            headerName: 'Period End Date', 
            minWidth : 180,
            valueGetter: (params) => moment(params.row.End_Date).format('MM/DD/YYYY'),
        },
        { 
            field: 'time left', 
            headerName: 'Time Left', 
            minWidth : 170,
            valueGetter: (params) => params?.row?.time_remaining?.formatted,
        },
        {
            field: 'Group_Code', headerName: 'Group Code', flex: 1, maxWidth : 170,
            renderCell: (params) => {
                return (
                    <Chip
                        sx={{
                            backgroundColor: '#0d6efd',
                            color: '#ffffff',
                            cursor: 'pointer',
                            width: '40px'
                        }}
                        label={params.row.group?.SO_Desc}
                    />  
                );
            }
        },
        {
            field: 'status', headerName: 'Status', flex: 1, maxWidth : 180,
            renderCell: (params) => {
                return (
                    <Chip
                        sx={{
                            backgroundColor: params.row.members[0].Status == "approved" ? '#008000' :  params.row.members[0].Status == "requested" ? 'orange' : '#000000',
                            color: '#ffffff',
                            cursor: 'pointer',
                            width: '100px'
                        }}
                        label={params.row.members[0].Status == 'approved' ? 'Finished' : params.row.members[0].Status.charAt(0).toUpperCase() + params.row.members[0].Status.slice(1).toLowerCase()}
                    />  
                );
            }
        },
        {
            field: 'actions', headerName: 'Actions', flex: 1, minWidth : 140,
            renderCell: (params) => {
                return (
                    <>
                        <ButtonTheme variant="filled" color='primary' className='rounded-2' disabled={params?.row?.members[0].Status == 'pending' || params?.row?.members[0].Status == 'approved' || params?.row?.time_remaining?.is_expired === true }
                            onClick={() => navigate(`/firehouse/vacation-bid-user/${params?.row?.members[0].Vacation_Bid_Id}`)} 
                            >
                            Apply Vacation Bid
                        </ButtonTheme>
                        <ButtonTheme variant="filled" color='primary' className='rounded-2 mx-2' disabled={params?.row?.members[0].Status == 'pending'}
                            onClick={() => {
                                setShowModal(true)
                                getTotalBids(params?.row)
                                setSelectedData(params?.row)
                            }}>
                            Total Bids Pick
                        </ButtonTheme>
                    </>
                );
            }
        },
    ];

    const getMyBids = (loader = true) => {
        if (loader) {
            setLoading(true)
        }
        ApiService.get('/getMyBids')
            .then(({ data }) => {
                setBidsData(data?.data || [])
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                // toast.error(e?.response?.data?.message || "error")
            })
    }

    useEffect(()=>{
        getMyBids()
    }, [])

    const getTotalBids = (data) =>{
        ApiService.get(`/getMyBidPicks/${data?.members[0].Vacation_Bid_Id}`).then(({ data }) => {
            setMyBidsData(data?.data || [])
            }).catch((err) => {
            console.error(err.response.data.message || 'error')
        })
    }

    return (
        <>
            <>
                {loading ? (
                    <Paper className="w-100 h-100 d-flex justify-content-center align-items-center font-fam">
                        <CircularProgress />
                    </Paper>
                    )
                    :
                    (
                        <>
                            <Paper className="p-4 font-fam" style={{ marginTop: "1rem", minHeight: '98%' }}>
                                <Grid container className='align-items-center' gap={2} style={{ gap: "24px", marginTop: "7px" }} >
                                    <Grid item xs={10} md={4}>
                                        <Typography variant="h5">My Vacation Bids</Typography>
                                    </Grid>
                                </Grid>

                                <div>
                                    {(bidsData?.length === 0) ?
                                        <Box>
                                            <div className='inner-box d-flex flex-column align-items-center justify-content-center' style={{ height: 530 }}>
                                                <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                                                <div className='mt-2' style={{ color: '#555555' }}>
                                                    Empty Vacation Bids
                                                </div>
                                            </div>
                                        </Box>
                                    :
                                        <>
                                            <div className='mt-3'>
                                                <MyTable
                                                    rows={bidsData}
                                                    columns={columns}
                                                    rowCount={bidsData.length}
                                                    checkboxSelection={false}
                                                    hideFooter={bidsData.length > 100 ? false : true}
                                                />
                                            </div>
                                        </>
                                    }
                                </div>

                            </Paper >
                        </>
                )}
            </>

            { <>
                <style>{`
                    .custom-modal-lg {
                        padding: 0px 20px;
                    }
                `}</style>

                <Modal 
                    show={showModal} 
                    onHide={() => {
                        setShowModal(false)
                        setMyBidsData([])
                    }}
                    size="md"
                    dialogClassName="custom-modal-lg"
                >
                    <div
                        style={{
                            boxShadow: '0px 10px 60px rgba(0, 0, 0, 0.4)',
                            borderRadius: '6px',
                        }}
                    >
                        <Modal.Header closeButton>
                            <Modal.Title>View My Bids</Modal.Title>
                        </Modal.Header>
                            <Modal.Body>
                                {myBidsData && myBidsData?.length > 0 ?
                                    <Card variant="outlined" className='mb-2' sx={{borderRadius:'8px' , maxHeight:'70vh' , overflow:'scroll' , scrollbarWidth:'none'}}>
                                        <CardContent sx={{padding:'0px' , '&:last-child': {
                                                paddingBottom: 0,
                                            },}}>
                                            {myBidsData.map((item, index) => (
                                                <Box
                                                    key={index}
                                                    sx={{
                                                        justifyContent: 'space-between',
                                                    }}
                                                >
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 , padding:'8px'}}>
                                                        <Typography sx={{ fontWeight: 600 , minWidth:'220px' , marginLeft:'20px' }}> Shift Date : {moment(item?.Shift_Date).format("MM/DD/YYYY")}</Typography>
                                                        <Chip label={item?.shift?.Shift == '24' ? 'Day & Night' : `${item?.shift?.Shift || item?.shift?.Short_Desc}`} sx={{padding:'6px 16px' , backgroundColor:'#BF1D2D' , color:'#ffffff' , minWidth:'120px'}}/>
                                                    </Box>

                                                    {index < myBidsData.length - 1 && <Divider sx={{ width: '100%' , backgroundColor:'#cccccc' }} />}
                                                </Box>
                                            ))}
                                        </CardContent>
                                    </Card>
                                    : 
                                    <div className='d-flex flex-column align-items-center justify-content-center mb-3'>
                                        <img src='/images/blur-logo.png' style={{ height: 120, width: 150 }} />
                                        <span className='mt-4' style={{ color: '#555555' }}>
                                            No any bids
                                        </span>
                                    </div>
                                }
                            </Modal.Body>
                    </div>
                </Modal>
            </> }
        </>
    )
}
export default VacationBidsUser;
